import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from './images/company.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-126f7548"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "container long-container",
  id: "compileContent"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "row"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "col-lg-4 long-left"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "公司"
  })]), /*#__PURE__*/_createElementVNode("div", {
    class: "col-lg-8 long-right"
  }, [/*#__PURE__*/_createElementVNode("h2", null, "待优化"), /*#__PURE__*/_createElementVNode("p", null, "待完善。")])], -1);
});

var _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3);
}